/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GCSRestoreTarget } from '../models/GCSRestoreTarget';
import { S3RestoreTarget } from '../models/S3RestoreTarget';
import { StorageAccountRestoreTarget } from '../models/StorageAccountRestoreTarget';

export class ObjectStorageDestination {
  's3Bucket'?: S3RestoreTarget;
  'storageAccount'?: StorageAccountRestoreTarget;
  'gcsBucket'?: GCSRestoreTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "s3Bucket",
      "baseName": "s3Bucket",
      "type": "S3RestoreTarget",
      "format": ""
    },
    {
      "name": "storageAccount",
      "baseName": "storageAccount",
      "type": "StorageAccountRestoreTarget",
      "format": ""
    },
    {
      "name": "gcsBucket",
      "baseName": "gcsBucket",
      "type": "GCSRestoreTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ObjectStorageDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

